import { render, staticRenderFns } from "./ResetPassword.vue?vue&type=template&id=5d078c0f&scoped=true"
import script from "./ResetPassword.vue?vue&type=script&lang=js"
export * from "./ResetPassword.vue?vue&type=script&lang=js"
import style0 from "./ResetPassword.vue?vue&type=style&index=0&id=5d078c0f&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d078c0f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dusanvelickovic/Herd/bookybook/bookybook-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d078c0f')) {
      api.createRecord('5d078c0f', component.options)
    } else {
      api.reload('5d078c0f', component.options)
    }
    module.hot.accept("./ResetPassword.vue?vue&type=template&id=5d078c0f&scoped=true", function () {
      api.rerender('5d078c0f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/pages/auth/ResetPassword.vue"
export default component.exports